<template>
  <div>
    <el-input
      v-model="query.blandName"
      clearable=""
      style="margin-bottom: 10px;"
      placeholder="输入品牌名称搜索">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="handleCurrentChange(1)"></el-button>
    </el-input>
    <el-table
      v-loading="loading"
      highlight-current-row
      border
      height="500px"
      :row-class-name="tableRowClassName"
      :data="list">
      <el-table-column
        label="品牌名称"
        min-width="200"
        prop="blandName"></el-table-column>
      <el-table-column
        label="操作"
        width="80">
        <template slot-scope="{ row }">
          <el-link
            type="primary"
            @click="selectItem(row)">{{ row.blandId === config.blandId ? '已选择' : '选择' }}</el-link>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="query"
      :total="total"
      :fetch="fetchList" />
  </div>
</template>
<script>
import CustomApi from '@/service/custom'
export default {
  name: 'BrandTable',
  props: {
    config: { type: Object, default() { return { categoryId: null, categoryName: '', items: [], blandId: null, blandName: '', spuId: null, spuName: '' } } }
  },
  data() {
    return { loading: false, total: 0, query: { pageNum: 1, pageSize: 10, blandName: '' }, list: [] }
  },
  methods: {
    tableRowClassName({ row }) {
      return row.id === this.config.categoryAttributeId ? 'current-select-row' : ''
    },
    selectItem(row) {
      const { blandId, blandName } = row
      this.$emit('update', { blandId, blandName, spuId: null, spuName: '' }, 2)
    },
    handleCurrentChange(val) {
      this.query.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      CustomApi.getappraisalblands({ ...this.query, categoryId: this.config.categoryId })
        .then(res => {
          this.loading = false
          const { records, result, message, total } = res.data
          if ([0, -13].includes(result)) {
            this.total = total
            this.list = records.map(i => ({ blandId: i.id, blandName: i.blandName }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
